import { AppBundle } from 'api/optimalprint-sdk.d';
import cn from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import updateFilterAttributeOptionOperation from 'store/category/operation/updateFilterAttributeOptionOperation';
import { FilterAttributeGroup } from 'store/category/types';
import styles from './BlockValueOptions.module.scss';

export interface Props {
  attribute: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters.IFilterItem;
  group: FilterAttributeGroup;
}

const BlockValueOptions = ({ attribute, group }: Props) => {
  const dispatch = useDispatch();
  const setFilterOption = (value: string) => {
    dispatch(updateFilterAttributeOptionOperation(group, attribute.typeName, value));
  };

  return (
    <div className={styles.blockValueOptions}>
      {attribute.options?.map((option) => (
        <div
          key={option.value}
          className={cn(styles.option, {
            [styles.available]: option.isAvailable,
            [styles.selected]: option.isSelected,
          })}
          onClick={() => setFilterOption(option.value)}
        >
          {option.name}
        </div>
      ))}
    </div>
  );
};

export default BlockValueOptions;
